module.exports = __webpack_public_path__ + "images/apps/dingtalk-d74c82e730619e95b6e2e22f56aaa2ba.png";